// ─────────────────────────────────────────────────────────────
// src/hooks/useScreenSize.js
// Tracks window dimensions and provides responsive breakpoint flags.
// ─────────────────────────────────────────────────────────────

import { useState, useEffect } from "react";

const getSize = () => {
  const width = window.innerWidth;
  return {
    width,
    isMobile:  width <= 768,
    isTablet:  width > 768 && width <= 1024,
    isDesktop: width > 1024,
  };
};

/**
 * Returns live screen-size info.
 * @returns {{ width: number, isMobile: boolean, isTablet: boolean, isDesktop: boolean }}
 */
const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState(getSize);

  useEffect(() => {
    const handleResize = () => setScreenSize(getSize());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return screenSize;
};

export default useScreenSize;
